import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  index(params) {
    const url = apiRoutes.realEstateAgentLoanOfficersPath();

    return FetchHelpers.get(url, params);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/realEstateAgent/LoanOfficersRepository.js